import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['primary', 'secondary'];

  connect() {
    this.updateState(); // Initialize the state on page load
  }

  toggle(event) {
    const checkbox = event.target;

    if (checkbox.dataset.checkboxTarget === 'primary') {
      this.handlePrimaryToggle(checkbox);
    } else if (checkbox.dataset.checkboxTarget === 'secondary') {
      this.handleSecondaryToggle(checkbox);
    }
  }

  handlePrimaryToggle(primaryCheckbox) {
    const secondaryCheckbox = primaryCheckbox
      .closest('tr')
      .querySelector("[data-checkbox-target='secondary']");

    // Uncheck secondary if primary is unchecked
    if (!primaryCheckbox.checked) {
      secondaryCheckbox.checked = false;
    }

    this.updateHiddenField(primaryCheckbox, secondaryCheckbox);
  }

  handleSecondaryToggle(secondaryCheckbox) {
    const primaryCheckbox = secondaryCheckbox
      .closest('tr')
      .querySelector("[data-checkbox-target='primary']");

    // Ensure primary is checked if secondary is clicked
    if (secondaryCheckbox.checked) {
      primaryCheckbox.checked = true;
    }

    this.updateHiddenField(primaryCheckbox, secondaryCheckbox);
  }

  updateHiddenField(primaryCheckbox, secondaryCheckbox) {
    const hiddenField = primaryCheckbox
      .closest('tr')
      .querySelector(`#hidden_email_${primaryCheckbox.dataset.checkboxTarget}`);
    if (hiddenField) {
      hiddenField.value = secondaryCheckbox.checked;
    }
  }

  updateState() {
    this.primaryTargets.forEach((primaryCheckbox) => {
      const secondaryCheckbox = primaryCheckbox
        .closest('tr')
        .querySelector("[data-checkbox-target='secondary']");
      // Ensure consistent state on page load
      if (!primaryCheckbox.checked) {
        secondaryCheckbox.checked = false;
      }
    });
  }
}
